import React from 'react';
import {Button, DialogActions, DialogTitle, Typography} from '@mui/material';
import {BaseBilling} from 'app/components/entities/billing/base';

interface Props {
  coupon: BaseBilling.Coupon;
  onClose: () => void;
}

export function ActivatedCoupon({coupon, onClose}: Props) {
  return (
    <>
      <DialogTitle>
        You have got{' '}
        <Typography
          data-id="voucher-value"
          component="span"
          variant="inherit"
          color="secondary.main"
        >
          {coupon.applies_to_display}
        </Typography>{' '}
        on your account.
      </DialogTitle>

      <DialogActions>
        <Button
          data-id="modal_close_button"
          variant="contained"
          color="secondary"
          autoFocus={true}
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </>
  );
}
